import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import InputOutputHelper from "bpmn-js-properties-panel/lib/helper/InputOutputHelper";
import delegate from "bpmn-js-properties-panel/lib/provider/camunda/parts/implementation/Delegate";
import external from "bpmn-js-properties-panel/lib/provider/camunda/parts/implementation/External";
import resultVariable from "bpmn-js-properties-panel/lib/provider/camunda/parts/implementation/ResultVariable";
import {
  escapeHTML,
  triggerClickEvent,
} from "bpmn-js-properties-panel/lib/Utils";
import {
  query as domQuery,
  closest as domClosest,
  classes as domClasses,
} from "min-dom";

import callable from "./Callable";
import implementationType from "./ImplementationType";
import ImplementationTypeHelper from "./ImplementationTypeHelper";

function getImplementationType(element) {
  return ImplementationTypeHelper.getImplementationType(element);
}

function getBusinessObject(element) {
  return ImplementationTypeHelper.getServiceTaskLikeBusinessObject(element);
}

function isDmnCapable(element) {
  return ImplementationTypeHelper.isDmnCapable(element);
}

function isExternalCapable(element) {
  return ImplementationTypeHelper.isExternalCapable(element);
}

function isServiceTaskLike(element) {
  return ImplementationTypeHelper.isServiceTaskLike(element);
}

function isRegistrarDocumentoSupportCapable(element) {
  return ImplementationTypeHelper.isRegistrarDocumentoSupportCapable(element);
}

function isGerarMinutaSupportCapable(element) {
  return ImplementationTypeHelper.isGerarMinutaSupportCapable(element);
}

function isGerarPdfRegistrarSupportCapable(element) {
  return ImplementationTypeHelper.isGerarPdfRegistrarSupportCapable(element);
}

function isRegistrarArquivarDocumentoSupportCapable(element) {
  return ImplementationTypeHelper.isRegistrarArquivarDocumentoSupportCapable(
    element,
  );
}

function isGerarPdfNewSupportCapable(element) {
  return ImplementationTypeHelper.isGerarPdfNewSupportCapable(element);
}

function isGerarXmlSupportCapable(element) {
  return ImplementationTypeHelper.isGerarXmlSupportCapable(element);
}

function isIntegrarDoczSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarDoczSupportCapable(element);
}

function isIntegrarDoczEtiquetaSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarDoczEtiquetaSupportCapable(element);
}

function isIntegrarDoczSesiSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarDoczSesiSupportCapable(element);
}

function isIntegrarSeiSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarSeiSupportCapable(element);
}

function isIntegrarAssinaturaSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarAssinaturaSupportCapable(element);
}

function isIntegrarAssinaturaLoteSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarAssinaturaLoteSupportCapable(element);
}

function isIntegrarAssinaturaLoteGetResultSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarAssinaturaLoteGetResultSupportCapable(element);
}

function isIntegrarApiManagerSupportCapable(element) {
  return ImplementationTypeHelper.isIntegrarApiManagerSupportCapable(element);
}

function isGerarQrBarCodeSupportCapable(element) {
  return ImplementationTypeHelper.isGerarQrBarCodeSupportCapable(element);
}

export default function (group, element, bpmnFactory, translate, modeling) {
  if (!isServiceTaskLike(getBusinessObject(element))) {
    return;
  }

  const hasDmnSupport = isDmnCapable(element);
  const hasExternalSupport = isExternalCapable(getBusinessObject(element));
  const hasRegistrarDocumentoSupport = isRegistrarDocumentoSupportCapable(
    getBusinessObject(element),
  );
  const hasGerarMinutaSupport = isGerarMinutaSupportCapable(
    getBusinessObject(element),
  );
  const hasGerarPdfRegistrarSupport = isGerarPdfRegistrarSupportCapable(
    getBusinessObject(element),
  );

  const hasRegistrarArquivarDocumentoSupport =
    isRegistrarArquivarDocumentoSupportCapable(getBusinessObject(element));
  const hasGerarPdfNewSupport = isGerarPdfNewSupportCapable(
    getBusinessObject(element),
  );
  const hasGerarXmlSupport = isGerarXmlSupportCapable(
    getBusinessObject(element),
  );
  const hasIntegrarDoczSupport = isIntegrarDoczSupportCapable(
    getBusinessObject(element),
  );
  const hasIntegrarDoczEtiquetaSupport = isIntegrarDoczEtiquetaSupportCapable(
    getBusinessObject(element),
  );

  const hasIntegrarDoczSesiSupport = isIntegrarDoczSesiSupportCapable(getBusinessObject(element));
  const hasIntegrarSeiSupport = isIntegrarSeiSupportCapable(getBusinessObject(element));

  const hasIntegrarAssinaturaSupport = isIntegrarAssinaturaSupportCapable(
    getBusinessObject(element),
  );

  const hasIntegrarAssinaturaLoteSupport = isIntegrarAssinaturaLoteSupportCapable(getBusinessObject(element));
  const hasIntegrarAssinaturaLoteGetResultSupport = isIntegrarAssinaturaLoteGetResultSupportCapable(getBusinessObject(element));

  const hasIntegrarApiManagerSupport = isIntegrarApiManagerSupportCapable(
    getBusinessObject(element),
  );

  const hasGerarQrBarCodeSupport = isGerarQrBarCodeSupportCapable(
    getBusinessObject(element)
  );

  // implementation type ////////////////////////////////////
  //~Incluir o Tipo BRMS para a exibição no camunda
  group.entries = group.entries.concat(
    implementationType(
      element,
      bpmnFactory,
      {
        getBusinessObject,
        getImplementationType,
        hasDmnSupport,
        hasBrmsSupport: hasDmnSupport,
        hasExternalSupport,
        hasServiceTaskLikeSupport: true,
        hasRegistrarDocumentoSupport,
        hasGerarMinutaSupport,
        hasGerarPdfRegistrarSupport,
        hasRegistrarArquivarDocumentoSupport,
        hasGerarPdfNewSupport,
        hasGerarXmlSupport,
        hasIntegrarDoczSupport,
        hasIntegrarDoczEtiquetaSupport,
        hasIntegrarDoczSesiSupport,
        hasIntegrarSeiSupport,
        hasIntegrarAssinaturaSupport,
        hasIntegrarAssinaturaLoteSupport,
        hasIntegrarAssinaturaLoteGetResultSupport,
        hasIntegrarApiManagerSupport,
        hasGerarQrBarCodeSupport,
      },
      translate,
    ),
  );

  // delegate (class, expression, delegateExpression) //////////

  group.entries = group.entries.concat(
    delegate(
      element,
      bpmnFactory,
      {
        getBusinessObject,
        getImplementationType,
      },
      translate,
    ),
  );

  // result variable /////////////////////////////////////////

  group.entries = group.entries.concat(
    resultVariable(
      element,
      bpmnFactory,
      {
        getBusinessObject,
        getImplementationType,
        hideResultVariable(element, node) {
          return getImplementationType(element) !== "expression";
        },
      },
      translate,
    ),
  );

  // external //////////////////////////////////////////////////

  if (hasExternalSupport) {
    group.entries = group.entries.concat(
      external(
        element,
        bpmnFactory,
        {
          getBusinessObject,
          getImplementationType,
        },
        translate,
      ),
    );
  }

  // dmn ////////////////////////////////////////////////////////

  if (hasDmnSupport) {
    group.entries = group.entries.concat(
      callable(
        element,
        bpmnFactory,
        {
          getCallableType: getImplementationType,
        },
        translate,
        modeling,
      ),
    );
  }

  // Registrar Documento | Gerar Minuta | Gerar PDF e registrar /////////////////////////////////////////////

  if (
    hasRegistrarDocumentoSupport ||
    hasGerarMinutaSupport ||
    hasGerarPdfRegistrarSupport
  ) {
    group.entries = group.entries.concat(
      callable(
        element,
        bpmnFactory,
        {
          getCallableType: getImplementationType,
        },
        translate,
        modeling,
      ),
    );
  }

  // Registrar Arquivar | Gerar PDF | Gerar XML | Integrar Docz | Integrar Docz Etiqueta | Integrar Docz (Sesi) | Integrar Assinatura | Api Manager

  if (
    hasRegistrarArquivarDocumentoSupport ||
    hasGerarPdfNewSupport ||
    hasGerarXmlSupport ||
    hasIntegrarDoczSupport ||
    hasIntegrarDoczEtiquetaSupport ||
    hasIntegrarDoczSesiSupport ||
    hasIntegrarSeiSupport ||
    hasIntegrarAssinaturaSupport ||
    hasIntegrarAssinaturaLoteSupport || 
    hasIntegrarAssinaturaLoteGetResultSupport ||
    hasIntegrarApiManagerSupport ||
    hasGerarQrBarCodeSupport
  ) {
    group.entries = group.entries.concat(
      callable(
        element,
        bpmnFactory,
        {
          getCallableType: getImplementationType,
        },
        translate,
        modeling,
      ),
    );
  }

  // connector ////////////////////////////////////////////////

  const isConnector = function (element) {
    return getImplementationType(element) === "connector";
  };

  group.entries.push(
    entryFactory.link(translate, {
      id: "configureConnectorLink",
      buttonLabel: translate("Configure Connector"),
      handleClick(element, node, event) {
        const connectorTabEl = getTabNode(node, "connector");

        if (connectorTabEl) {
          triggerClickEvent(connectorTabEl);
        }

        // suppress actual link click
        return false;
      },
      showLink(element, node) {
        const link = domQuery("a", node);
        link.textContent = "";

        domClasses(link).remove("bpp-error-message");

        if (isConnector(element)) {
          const connectorId =
            InputOutputHelper.getConnector(element).get("connectorId");
          if (connectorId) {
            link.textContent = translate("Configure Connector");
          } else {
            link.innerHTML =
              '<span class="bpp-icon-warning"></span> ' +
              escapeHTML(translate("Must configure Connector"));
            domClasses(link).add("bpp-error-message");
          }

          return true;
        }

        return false;
      },
    }),
  );
}

// helpers ///////////////////////////

function getTabNode(el, id) {
  const containerEl = domClosest(el, ".bpp-properties-panel");

  return domQuery('a[data-tab-target="' + id + '"]', containerEl);
}
